// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import axios from "axios";
import breakpoints from "assets/theme/base/breakpoints";
// Vision UI Dashboard PRO React base styles
import typography from "assets/theme/base/typography";
// Vision UI Dashboard PRO React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import Footer from "examples/Footer";
import Header from "examples/Header";
import Globe from "examples/Globe";
// Vision UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import VehicleTypeTable from "layouts/homepage/components/VehicleTypeTable";
// Data
import vehicleTableData from "layouts/homepage/data/vehicleTypesData";
import {FreightIndexZonesTimePeriods, FreightIndexZones, FreightIndexVehicleTypes} from "./data/freightIndexChart";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha
} from 'react-google-recaptcha-v3';

// icons
import React, {useEffect, useMemo, useState} from "react";
import logo from "../../assets/images/logo_white.png";
import CircularProgress from "@mui/material/CircularProgress";
import PMTPKChart from "./components/PMTPKChart";
import FuelPriceBoxes from "./components/FuelPriceBoxes";
import DefaultLineChart from "../../examples/Charts/LineCharts/DefaultLineChart";
import {
lineChartDataDefault,
lineChartOptionsDefault
} from "../pages/charts/data/defaultLineChartData";
import RadarChart from "../../examples/Charts/RadarChart";
import {radarChartData, radarChartOptions} from "../pages/charts/data/radarChartData";
import SP_API from "../../components/API.js";
import Configurator from "../../components/Configurator";
import {LockOpen, Lock, DirectionsCar, Person, CreditCard} from "@mui/icons-material";
import {setOpenConfigurator, useVisionUIController} from "../../context";
import Faq from "../../components/Faq";
import { Link } from "react-router-dom";

function Default() {
const {values} = breakpoints;
  const [controller, dispatch] = useVisionUIController();
  const { openConfigurator } = controller;
  const [chartData, setChartData] = useState({});
  const [PMTPKloading, setPMTPKLoading] = useState(true);
  const [vehicleTypeLoading, setVehicleTypeLoading] = useState(true);
  const [radarLoading, setRadarLoading] = useState(true);
  const [PMTPKzones, setPMTPKzones] = useState([FreightIndexZones[0], FreightIndexZones[1]]);
  const [numberOfMonths, setNumberOfMonths] = useState(FreightIndexZonesTimePeriods[1]);
  const [vehicleType, setVehicleType] = useState(FreightIndexVehicleTypes[0]);
  const [vehicleTypeData, setVehicleTypeData] = useState(vehicleTableData);
  const [loggedIn, setLoggedIn] = useState(false);
  const [userDetails, setUserDetails] = useState({});

  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  const checkAuthentication = () => {
    const token = localStorage.getItem('token');
    return token !== null && token !== '';
  };

  // Check authentication status on component mount
  React.useEffect(() => {
    const isAuthenticated = checkAuthentication();
    setLoggedIn(isAuthenticated);
    
    if (isAuthenticated) {
      // Get user details from localStorage
      const storedUserDetails = localStorage.getItem('userDetails');
      if (storedUserDetails) {
        try {
          const userDetails = JSON.parse(storedUserDetails);
          setUserDetails(userDetails);
        } catch (e) {
          console.error('Error parsing user details:', e);
          setUserDetails({ name: 'User' });
        }
      } else {
        setUserDetails({ name: 'User' });
      }
    }
  }, []);
  

// Change the openConfigurator state
  const configsButton = (
    <VuiBox
      id="floating_lock_button"
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.5rem"
      height="3.5rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="5rem"
      zIndex={99}
      color="white"
      sx={({ palette: { info, success } }) => ({ 
        cursor: "pointer", 
        backgroundColor: loggedIn ? success.main : info.main 
      })}
      onClick={handleConfiguratorOpen}
    >
      {loggedIn ? (
        <Lock id="floating_lock_button" fontSize="default" color="inherit">
          {userDetails.name ? userDetails.name.split(' ')[0] : 'User'}
        </Lock>
      ) : (
        <LockOpen id="floating_lock_button" fontSize="default" color="inherit">
          Login
        </LockOpen>
      )}
    </VuiBox>
  );

  function effectFunction() {
    SP_API({ method:"POST", data: { PMTPKzones, numberOfMonths, vehicleType:vehicleType.value} }).then((response_json) => {
      setPMTPKLoading(false);
      setVehicleTypeLoading(false);
      setRadarLoading(false);
      if (response_json) {
        if (response_json.userDetails && response_json.userDetails.name) {
          const userDetails = response_json.userDetails;
  
          window.dataLayer.push({
            user_name: userDetails.name,
            user_org: userDetails.organization,
            user_email: userDetails.email || null,
            is_sp_user: userDetails.isSPUser,
            event: "freightIndex_user_logged_in"
          });
          setLoggedIn(true);
          setUserDetails(userDetails);
        }

        let vehicleTypesTable = [
          {...vehicleTableData[0], ...response_json.vehicleTypesData[0]},
          {...vehicleTableData[1], ...response_json.vehicleTypesData[1]},
          {...vehicleTableData[2], ...response_json.vehicleTypesData[2]},
          {...vehicleTableData[3], ...response_json.vehicleTypesData[3]},
          {...vehicleTableData[4], ...response_json.vehicleTypesData[4]}
        ];

        if (response_json.radarZoneData) {
          response_json.radarZoneData = response_json.radarZoneData.map(value => {return parseInt(value)});
          response_json.radarFuelData = response_json.radarFuelData.map(value => {return parseInt(value)});

          const radarData = radarChartData;

          radarData[0].data = response_json.radarZoneData;
          radarData[1].data = response_json.radarFuelData;
          response_json.radarData = radarData;
        }

        setChartData(response_json);
        setVehicleTypeData(vehicleTypesTable);
      }
    }).catch(err => {
      console.log(err);
    });
  }

  useEffect( () => {
    setPMTPKLoading(true);
    if (!vehicleTypeLoading) {
      effectFunction();
    }
  }, [PMTPKzones, numberOfMonths]);

  useEffect( () => {
    if (chartData) {
      setVehicleTypeLoading(true);
      effectFunction();
    }
  }, [vehicleType]);

  const onZoneChange = (zones) => { 
    let openMenuLength = zones && zones.filter((item) => item.isOpenMenu).length;
    if(openMenuLength === 0) {
      setPMTPKzones(zones);
    } else {
      handleConfiguratorOpen();
    }
  };

  const onTimePeriodChange = (timePeriod) => {
    if(!timePeriod.isOpenMenu) {
      setNumberOfMonths(timePeriod);
    } else {
      handleConfiguratorOpen();
    }
  }

  const onVehicleTypeChange = (vehicleType) => {    
    setVehicleType(vehicleType);
  }

  return (<>
    <Header />
    <Grid item xs={12}>
        <VuiBox 
          mb={0} 
          // py={8}         
          sx={({ breakpoints }) => ({
            py: 5,
            background: 'url(https://www.superprocure.com/wp-content/uploads/2022/11/home_bg_sp.jpg) center no-repeat', backgroundSize: 'cover',
            [breakpoints.down("sm")]: {
              py: 4,
            }
          })}
          px={2}
        >
          <VuiTypography
            variant={window.innerWidth < values.sm ? "h3" : "h2"}
            textTransform="capitalize"
            fontWeight="800"
            color={'white'}
            textAlign="center"
            mb={!loggedIn && '12px'}
          >
            SP Indian Freight Index
          </VuiTypography>          
          <VuiBox mb={1} mt={1} lineHeight="24px" style={{maxWidth: '1170px', margin: '0 auto 20px', textAlign: 'center'}}>
            <VuiTypography variant="p"
              fontSize="18px"
              lineHeight="24px"
              fontWeight="400"
              textAlign="center"
              color="white">
                The benchmarking tool measures transportation costs in India based on factors such as geographic locations, vehicle types, zones, and distances. It uses data collected from multiple carriers and helps businesses monitor transportation cost trends to make informed logistics decisions.
            </VuiTypography>
          </VuiBox>
          {!loggedIn ? 
          <p style={{fontSize: '18px', color: '#ffffff', lineHeight: '24px', textAlign: 'center'}}>
            Unlock unlimited usage and all the features with a <Link id="free_account_button" onClick={handleConfiguratorOpen} style={{color: 'white', borderBottom: '1px dotted #ffffff'}}>Free Account</Link>
          </p>
          : null}
        </VuiBox>
    </Grid>
    <DashboardLayout>
      <Grid py={3}>
        <Grid container>
          {/* Navigation Cards */}
          <Grid item xs={12} mb={4}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <Card 
                  sx={{ 
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
                    }
                  }}
                  onClick={() => window.location.href = '/#/verify-vahan'}
                >
                  <VuiBox p={3} textAlign="center">
                    <DirectionsCar sx={{ fontSize: 48, color: '#3b3663', mb: 2 }} />
                    <VuiTypography variant="h6" fontWeight="bold" color="dark" mb={1}>
                      Verify Trucks
                    </VuiTypography>
                    <VuiTypography variant="body2" color="text">
                      Verify truck registration details using Vahan database
                    </VuiTypography>
                  </VuiBox>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6} md={4}>
                <Card 
                  sx={{ 
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
                    }
                  }}
                  onClick={() => window.location.href = '/#/verify-sarathi'}
                >
                  <VuiBox p={3} textAlign="center">
                    <Person sx={{ fontSize: 48, color: '#3b3663', mb: 2 }} />
                    <VuiTypography variant="h6" fontWeight="bold" color="dark" mb={1}>
                      Verify Drivers
                    </VuiTypography>
                    <VuiTypography variant="body2" color="text">
                      Verify driver license details using Sarathi database
                    </VuiTypography>
                  </VuiBox>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6} md={4}>
                <Card 
                  sx={{ 
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
                    }
                  }}
                  onClick={() => window.location.href = '/#/track-fastag'}
                >
                  <VuiBox p={3} textAlign="center">
                    <CreditCard sx={{ fontSize: 48, color: '#3b3663', mb: 2 }} />
                    <VuiTypography variant="h6" fontWeight="bold" color="dark" mb={1}>
                      Track Fastag
                    </VuiTypography>
                    <VuiTypography variant="body2" color="text">
                      Track vehicle movements and toll transactions
                    </VuiTypography>
                  </VuiBox>
                </Card>
              </Grid>
            </Grid>
          </Grid>
          
          {/* <Grid item xs={5} lg={2} pt={1} alignContent={"right"} textAlign={"right"}>
            <VuiBox component="img" src={logo} alt={"SuperProcure"} width="100%" height="auto"/>{" "}
          </Grid> */}
          
          

          <Grid container spacing={3} mt={0} sx={{ display: { xs: 'block', sm: 'block', md: 'block', lg: 'flex' } }}>
            <Grid item xs={12} lg={4} style={{paddingTop: '0'}}>
              <Grid container>
                <Grid item xs={12} md={4} lg={12} mb={3} mt={6} style={{textAlign: 'center'}}>
                  {useMemo(
                    () => (
                  <VuiBox sx={{position: 'relative', display: 'inline-flex'}}>
                    <VuiBox sx={{ position: 'relative' }}>
                      <CircularProgress variant="determinate"
                          sx={{
                            color: (theme) =>
                              theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                          }} size={200} value={100} />
                      <CircularProgress variant='determinate' value={chartData.latestFreightIndex} size={200} color='success' 
                        sx={{
                          position: 'absolute',
                          left: 0,
                        }} />
                    </VuiBox>
                    {/* <CircularProgress variant='determinate' value={chartData.latestFreightIndex} size={200} color='success'/> */}
                    <VuiBox
                      sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                      <VuiBox
                        display='flex'
                        flexDirection='column'
                        justifyContent='center'
                        alignItems='center'>

                        <VuiTypography color='brand' variant='h2' fontWeight='bold'>
                          {chartData.latestFreightIndex ? chartData.latestFreightIndex : <CircularProgress size={"2rem"} color={"text"}/>}
                        </VuiTypography>
                        <VuiTypography color='text' variant='caption'>
                          Freight Index
                        </VuiTypography>
                        <VuiTypography
                          variant="button"
                          color={chartData.latestFreightIndexDifference > 0 ? "error": (chartData.latestFreightIndexDifference < 0 ? "success": "text")}
                          fontWeight="bold"
                          sx={({breakpoints}) => ({
                            [breakpoints.only("lg")]: {
                              fontSize: "10px",
                            },
                            [breakpoints.only("xl")]: {
                              fontSize: "12px",
                            },
                          })}
                        >
                          {chartData.latestFreightIndexDifference}%
                          <span style={{fontSize: '20px', fontWeight: '700'}}>
                            {chartData.latestFreightIndexDifference > 0 ? "↓ " : (chartData.latestFreightIndexDifference < 0 ? "↑ ": "")}
                          </span>
                        </VuiTypography>
                        <VuiTypography color='text' variant='caption'>
                          in {chartData.latestFreightIndexMonth && chartData.latestFreightIndexMonth.substring(0, 3) + " '" + chartData.latestFreightIndexMonth.slice(-2)}
                          {" "} vs. {" "}
                          {chartData && chartData.months && chartData.months.length > 0 ? chartData.months[chartData?.months?.length - 2].substring(0, 3) + " '" + chartData.months[chartData?.months?.length - 2].slice(-2) : ''}
                        </VuiTypography>
                      </VuiBox>
                    </VuiBox>
                  </VuiBox>
                    ), [chartData])}
                </Grid>

                {/* <Grid item xs={12} md={8} lg={12} mb={3}>
                  <Card mb={3}>
                    <VuiBox mb={1}>
                      <VuiTypography variant="h5" textTransform="capitalize"
                        fontWeight="800"
                        color="#3b3663">
                          Diesel price
                      </VuiTypography>
                    </VuiBox>
                    <FuelPriceBoxes prices={chartData?.fuelPrices} />
                  </Card>
                </Grid> */}

                {useMemo(
                  () => (
                    <RadarChart
                      loaderState={radarLoading}
                      title="Freight Index & fuel price"
                      data={chartData?.radarData}
                      options={radarChartOptions}
                    />
                  ),
                  [chartData]
                )}
              </Grid>

            </Grid>

            <Grid item xs={12} lg={8}>
              {useMemo(
                () => (
              <PMTPKChart
                months={chartData?.months}
                lines={chartData?.PMTPKlines}
                zone={PMTPKzones}
                timePeriod={numberOfMonths}
                zoneChange={onZoneChange}
                timePeriodChange={onTimePeriodChange}
                loaderState={PMTPKloading}
                loggedIn={loggedIn}
                PMTPKdifference={chartData?.PMTPKdifference}
              />
                ), [chartData, PMTPKloading])}

              <Grid mt={2}>
                <Card>
                  {useMemo(
                    () => (
                      <VehicleTypeTable title="Freight based on vehicle type and distance" rows={vehicleTypeData} value={vehicleType} loaderState={vehicleTypeLoading} loggedIn={loggedIn} onChange={onVehicleTypeChange} handleConfiguratorOpen={handleConfiguratorOpen} />
                    ), [vehicleTypeData, vehicleTypeLoading])}
                </Card>
              </Grid>

              <Grid mt={2}>
              {useMemo(
                () => (
                  <>
                  {(chartData && chartData.FIlines) ?
                    <DefaultLineChart
                      title="Freight index"
                      data={chartData?.FIlines}
                      options={lineChartOptionsDefault}
                      months={chartData?.months}
                    /> : ""}
                  </>
                ),
                [chartData]
              )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Faq loggedIn={loggedIn} />
      <>
        <Configurator userDetails={loggedIn ? userDetails : null} isShowConfig={!openConfigurator} />
        {configsButton}
      </>
    </DashboardLayout>
    <Footer/>
    </>
  );
}

export default Default;
